import ResumenCreacionClass from './ResumenCreacionClass';

export default ResumenCreacionClass;
